(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fd-collection-coupon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const copyBtn = event.target.closest('.copy-coupon-btn');
    if (copyBtn) {
      const couponId = copyBtn.getAttribute('data-coupon-id');
      const couponElement = document.getElementById(couponId);
      
      if (couponElement) {
        const couponText = couponElement.textContent.trim();
        
        navigator.clipboard.writeText(couponText).then(function() {          
          const originalHTML = copyBtn.innerHTML;
          copyBtn.innerHTML = '<svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 10L2 7.5L3 6.5L4.5 8L8 4.5L9 5.5L4.5 10Z" fill="black"/></svg>';
          
          setTimeout(function() {
            copyBtn.innerHTML = originalHTML;
          }, 1500);
        }).catch(function(err) {
          console.error('Error al copiar: ', err);
        });
      }
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-color-variants"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const swiperElements = document.querySelectorAll('.fd-color-variants__swiper');
    
    swiperElements.forEach(function(element) {
      const slidesPerView = element.dataset.slidesPerView || 'auto';
      const enableArrows = element.dataset.enableArrows === 'true';
      const completeMode = element.dataset.completeMode === 'true';
      
      const swiperConfig = {
        slidesPerView: slidesPerView === 'auto' ? 'auto' : parseInt(slidesPerView),
        spaceBetween: 0,
      };
      
      if (enableArrows) {
        swiperConfig.navigation = {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        };
      }
      
      new Swiper(element, swiperConfig);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-raffle"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('.fd-raffle-component[data-raffle-ts]');
  if (!root) return;

  const timerEl = root.querySelector('.fd-raffle__timer');
  const daysEl = root.querySelector('[data-countdown-days]');
  const hoursEl = root.querySelector('[data-countdown-hours]');
  const minutesEl = root.querySelector('[data-countdown-minutes]');
  const secondsEl = root.querySelector('[data-countdown-seconds]');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  const target = Number(root.dataset.raffleTs) * 1000;

  const pad = (n) => String(n).padStart(2, '0');

  let intervalId;

  const tick = () => {
    const diff = target - Date.now();
    if (diff <= 0) {
      clearInterval(intervalId);
      // Hide countdown timer when expired
      if (timerEl) {
        timerEl.style.display = 'none';
      }
      return;
    }
    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    daysEl.textContent = pad(days);
    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  };

  tick();
  intervalId = setInterval(tick, 250);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-related-collections"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const swiperElements = document.querySelectorAll('.category-view-seoLinks[data-swiper-id]:not([data-swiper-initialized])');

    swiperElements.forEach(function(swiperElement) {
      const swiperId = swiperElement.dataset.swiperId;
      const prevButton = document.querySelector(`[data-swiper-prev="${swiperId}"]`);
      const nextButton = document.querySelector(`[data-swiper-next="${swiperId}"]`);
      
      if (!prevButton || !nextButton) {
        console.warn('Navigation buttons not found for swiper:', swiperId);
        return;
      }
      
      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      };
      
      new Swiper(swiperElement, swiperConfig);
      swiperElement.setAttribute('data-swiper-initialized', 'true');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-release"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('.fd-release-component[data-release-ts]');
  if (!root) return;

  const daysEl = root.querySelector('[data-countdown-days]');
  const hoursEl = root.querySelector('[data-countdown-hours]');
  const minutesEl = root.querySelector('[data-countdown-minutes]');
  const secondsEl = root.querySelector('[data-countdown-seconds]');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  const target = Number(root.dataset.releaseTs) * 1000;

  const pad = (n) => String(n).padStart(2, '0');

  let intervalId;

  const tick = () => {
    const diff = target - Date.now();
    if (diff <= 0) {
      clearInterval(intervalId);
      window.location.reload();
      return;
    }
    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    daysEl.textContent = pad(days);
    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  };

  tick();
  intervalId = setInterval(tick, 250);
})();
  } catch(e) { console.error(e); }
})();

})();
